<article class="alert-card" *ngIf="alert as currentAlert">
  <div class="alert-card__header">
    <span class="alert-card__severity" [class.alert-card__severity--medium]="currentAlert.severity === 'medium'" aria-hidden="true"></span>
    <span class="alert-card__title">{{ currentAlert.title }}</span>
    <span class="alert-card__kind" [class.alert-card__kind--gradual]="currentAlert.kind === 'Gradual'">{{ currentAlert.kind }}</span>
    <span class="alert-card__spacer"></span>
    <span class="alert-card__delta" [class.alert-card__delta--medium]="currentAlert.severity === 'medium'">{{ currentAlert.delta }}</span>
  </div>

  <span class="alert-card__summary">{{ currentAlert.summary }}</span>

  <span class="alert-card__agent">{{ currentAlert.owningAgentName }}</span>

  <button *ngIf="hasDetail" type="button" class="alert-card__detail-toggle" [attr.aria-expanded]="isDetailExpanded" (click)="toggleDetail()">
    {{ detailToggleLabel }}
    <svg-icon [src]="detailToggleIcon" class="alert-card__detail-icon" aria-hidden="true"></svg-icon>
  </button>

  <div class="alert-card__detail" *ngIf="isDetailExpanded">
    <gains-driver-list [drivers]="currentAlert.drivers"></gains-driver-list>
    <gains-suggested-path [path]="currentAlert.suggestedPath"></gains-suggested-path>
  </div>

  <gains-feedback-row [feedback]="feedback" [canAskDeo]="canAskDeo" (verdictGiven$)="onVerdictGiven($event)" (askDeo$)="onAskDeo()"></gains-feedback-row>
</article>
